/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Transcription_ErrorInputs */

const en_transcription_error = /** @type {(inputs: Transcription_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Transcription Error: ${i?.error}`)
};

const fr_transcription_error = /** @type {(inputs: Transcription_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur de transcription : ${i?.error}`)
};

const de_transcription_error = /** @type {(inputs: Transcription_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Transkriptionsfehler: ${i?.error}`)
};

const it_transcription_error = /** @type {(inputs: Transcription_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore di trascrizione: ${i?.error}`)
};

const ru_transcription_error = /** @type {(inputs: Transcription_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка транскрипции: ${i?.error}`)
};

const es_transcription_error = /** @type {(inputs: Transcription_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error de transcripción: ${i?.error}`)
};

const zh_cn2_transcription_error = /** @type {(inputs: Transcription_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`转录错误：${i?.error}`)
};

const ja_transcription_error = /** @type {(inputs: Transcription_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`転写エラー: ${i?.error}`)
};

const hi_transcription_error = /** @type {(inputs: Transcription_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रतिलेखन त्रुटि: ${i?.error}`)
};

const pt_pt2_transcription_error = /** @type {(inputs: Transcription_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro de transcrição: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Transcription Error: {error}" |
*
* @param {Transcription_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_error = /** @type {((inputs: Transcription_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcription_error(inputs)
	if (locale === "de") return de_transcription_error(inputs)
	if (locale === "it") return it_transcription_error(inputs)
	if (locale === "ru") return ru_transcription_error(inputs)
	if (locale === "es") return es_transcription_error(inputs)
	if (locale === "zh-CN") return zh_cn2_transcription_error(inputs)
	if (locale === "ja") return ja_transcription_error(inputs)
	if (locale === "hi") return hi_transcription_error(inputs)
	if (locale === "pt-PT") return pt_pt2_transcription_error(inputs)
	return en_transcription_error(inputs)
});